import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6aa083a32253d30014ad2407_1788907537098_4e084fac/quantivait/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6aa083a32253d30014ad2407_1788907537098_4e084fac/quantivait/src/components/Header.tsx");
